import { ReactElement, useEffect, useState } from 'react';
import { useRouteLoaderData } from 'react-router-dom';

import {
  BussinessTypeRangeLives1Ids,
  BussinessTypeRangeLives1Tokens,
  BussinessTypeRangeLives2Ids,
  BussinessTypeRangeLives2Tokens,
  IndividualWithShortageNorthEastTokens,
} from '../../../utils/Enums/Tokens';
import { getSiglaSeExistir } from '../../../utils/getSiglaIfExists';
import { useBoostedPlanDataStore } from '../../../stores/useBoostedPlanDataStore';
import axios from 'axios';
import { useHireBussinessPlanForm } from '../../../contexts/HirePlanBussinessFormProvider';
import { fetchPlan } from '../../../requests/requests';
import { MultiSelect } from '../../Multiselect';
import { useCepStore } from '../../../stores/useCepStore';
import { useNortheastPlanDataStore } from '../../../stores/useNortheastPlanDataStore';
import { usePlanLoadingStore } from '../../../stores/usePlanLoadingStore';
import { usePlansDataStore } from '../../../stores/usePlansDataStore';
import {
  changeCivilStatus,
  changeGender,
  changeIssuingAgency,
  changeUF,
} from '../../../utils/ChangeArrays';
import { useCepValidator } from '../../../utils/useCepValidor';
import { isValidAbrange } from '../../../utils/ValidateAbrangencia';
import { isValidCEP, validateCEP } from '../../../utils/ValidateCEP';
import { validateCPF } from '../../../utils/ValidateCPF';
import { DualSelect } from '../../DualSelect';
import { Input } from '../../Input';
import { Select } from '../../Select';
import { GoForwardButton } from '../GoForwardButton';

interface Option {
  value: string;
  label: string;
}

export function BussinessRegisterForm(): ReactElement {
  const { register, handleSubmit, goToNextForm, errors, watch, setValue } =
    useHireBussinessPlanForm();
  const initialPlanData: any = useRouteLoaderData('token-empresa');
  const northeastPlanData = useNortheastPlanDataStore(state => state.data);
  const setNortheastPlanData = useNortheastPlanDataStore(
    state => state.setNortheastPlanData,
  );
  const setBoostPlanData = useBoostedPlanDataStore(x => x.setBoostPlanData);
  const setLoading = usePlanLoadingStore(state => state.setLoading);
  //const [planos, setPlanos] = useState<Option[]>([]);
  const planos = usePlansDataStore(state => state.data);
  const setPlanos = usePlansDataStore(state => state.setPlansData);
  const [selectedPlans, setSelectedPlans] = useState<Option[]>([]);
  const [isValorize, setValorize] = useState(false);
  const { validarCep } = useCepValidator();
  const [UF, setUF] = useState<number>(0);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (initialPlanData) {
      if (initialPlanData.corretora?.id_corretora === 77785) {
        setValorize(true);
        fetchPlansAvailable();
      }
    }
  }, [initialPlanData]);

  const fetchPlansAvailable = async () => {
    const urlBase = process.env.REACT_APP_OG_API_URL;
    const produtos = await axios.get(
      `${urlBase}/info/ProdutoByVendedorCateg?id_vendedor=${initialPlanData.vendedorId}&categ=${initialPlanData.produtoComercial.id_categoria_c}`,
    );
    const options = [];
    for (const produto of produtos.data) {
      const select = {
        value: produto.id_prodcomerc,
        label: `${
          produto.nm_prodcomerc
        } - somente R$ ${produto.formasPagamentoEmpresa[0].vl_valor.replace(
          '.',
          ',',
        )} por Vida`,
        price: produto.formasPagamentoEmpresa[0].vl_valor,
      };
      options.push(select);
    }
    setPlanos(options);
  };

  const CEP = watch('user.address.cep');
  const boostPlan = useBoostedPlanDataStore(x => x.data);

  useEffect(() => {
    if (UF > 0) {
      const abrangeRegiao = isValidAbrange(
        boostPlan?.produtoComercial?.abrangeRegiao,
        String(UF),
      );
      if (!abrangeRegiao) {
        alert('Produto não abrange região informada no cep');
        setValue('user.address.cep', '');
        return;
      }
    }
  }, [boostPlan]);

  const [data, setData] = useState(initialPlanData);
  const [newData, setnewData] = useState({});

  async function handleCEPChange(NE: boolean) {
    const vendedorId = initialPlanData.vendedorId;
    switch (initialPlanData.token) {
      case BussinessTypeRangeLives1Tokens.CLINICO:
      case BussinessTypeRangeLives1Tokens.CLINICO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives1Ids.CLINICO_NE
            : BussinessTypeRangeLives1Ids.CLINICO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives1Tokens.ORTO:
      case BussinessTypeRangeLives1Tokens.ORTO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives1Ids.ORTO_NE
            : BussinessTypeRangeLives1Ids.ORTO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives1Tokens.DOC:
      case BussinessTypeRangeLives1Tokens.DOC_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives1Ids.DOC_NE
            : BussinessTypeRangeLives1Ids.DOC,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives2Tokens.CLINICO:
      case BussinessTypeRangeLives2Tokens.CLINICO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives2Ids.CLINICO_NE
            : BussinessTypeRangeLives2Ids.CLINICO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives2Tokens.ORTO:
      case BussinessTypeRangeLives2Tokens.ORTO_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives2Ids.ORTO_NE
            : BussinessTypeRangeLives2Ids.ORTO,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
      case BussinessTypeRangeLives2Tokens.DOC:
      case BussinessTypeRangeLives2Tokens.DOC_NE: {
        const response = await fetchPlan(
          NE
            ? BussinessTypeRangeLives2Ids.DOC_NE
            : BussinessTypeRangeLives2Ids.DOC,
          vendedorId,
        );
        setnewData(response);
        setNortheastPlanData({ ...response, northeast: 1 });
        setBoostPlanData(response);
        break;
      }
    }
  }

  const getCEPDetails = async (e: string) => {
    const formatedCep = e.replace(/[^0-9]/g, '');
    if (formatedCep.length < 8) {
      return;
    }
    const CEPInformations = await fetch(
      `${process.env.REACT_APP_URL_BASE}/api/redeatendimento/Endereco?token=${process.env.REACT_APP_TOKEN_S4E_V2}&cep=${formatedCep}`,
      {
        method: 'POST',
      },
    ).then(response => response.json());

    setLoading(false);
    const NORDESTE_UFS = ['AL', 'PB', 'PE', 'RN', 'CE', 'BA', 'SE', 'MA', 'PI'];
    if (CEPInformations.dados == null) {
      alert('cep não encontrado na Base');
    }
    const SiglaUf = getSiglaSeExistir(CEPInformations.dados.Uf);
    if (!SiglaUf) {
      alert('Não foi possivel encontrar a UF correspondente ao CEP informado');
      setValue('user.address.cep', '');
      return;
    } else {
      handleCEPChange(NORDESTE_UFS.includes(SiglaUf));
    }
    const uf = initialPlanData.listaUFS.find(x => x.sigla == SiglaUf)?.Id;
    if (!uf) {
      alert('Não foi possivel encontrar a UF correspondente ao CEP informado');
      setValue('user.address.cep', '');
      return;
    }

    setUF(uf);
    setValue('user.address.city', CEPInformations.dados.Municipio);
    setValue('user.address.neighborhood', CEPInformations.dados.Bairro);
    setValue('user.address.street', CEPInformations.dados.Logradouro);
    setValue('user.address.uf', String(uf), { shouldValidate: true });

    return CEPInformations;
  };

  useEffect(() => {
    if (Object.keys(newData).length !== 0 && newData != data) {
      setData(newData);
    }
  }, [newData]);

  useEffect(() => {
    if (CEP && validateCEP.test(CEP)) {
      getCEPDetails(CEP);
    }
  }, [CEP]);

  useEffect(() => {
    if (Object.keys(northeastPlanData).length === 0) {
      setNortheastPlanData({ ...initialPlanData });
    }
  }, []);
  changeUF(data.listaUFS);
  changeGender(data.listaSexos);
  changeIssuingAgency(data.listaOrgaosExpedidor);
  changeCivilStatus(data.listaEstadosCivil);

  const validaValoriza = async () => {
    if (isValorize && selectedPlans.length === 0) {
      alert('Por favor, selecione pelo menos um produto comercializado.');
      return;
    } else if (!isValorize) {
      const PlanDefault = {
        value: initialPlanData.produtoComercial.id_prodcomerc,
        label: initialPlanData.produtoComercial.nm_prodcomerc,
        price: initialPlanData.formasPagamento[0].vl_valor,
      };
      setPlanos([PlanDefault]);
      setValue(
        'user.produtosComercializados',
        [
          {
            id: initialPlanData.produtoComercial.id_prodcomerc.toString(),
            nome: initialPlanData.produtoComercial.nm_prodcomerc,
          },
        ],
        { shouldValidate: true },
      );
    }
    const cep = watch('user.address.cep');
    const validateCep = validarCep(cep);
    if (!cep || !validateCep) {
      alert('Por favor, insira um CEP válido antes de continuar.');
      return;
    }
    handleSubmit(goToNextForm)();
  };

  return (
    <form action="" className="max-w-[766px] w-full">
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
        Dados Empresa
      </h2>

      <div className="grid min-[748px]:grid-cols-2 grid-cols-1 gap-6">
        <Input
          activateMask
          mask="99999-999"
          label="CEP"
          className="w-full"
          //onBlur={e => getPlanValueByCEP(e.target.value)}
          placeholder="CEP"
          errorMessage={errors.user?.address?.cep?.message}
          {...register('user.address.cep')}
        />
        <Input
          label="CNPJ"
          placeholder="CNPJ"
          activateMask
          mask="99.999.999/9999-99"
          errorMessage={errors.user?.documents?.cnpj?.message}
          {...register('user.documents.cnpj')}
        />
        <Input
          label="Razão Social"
          placeholder="Razão Social"
          errorMessage={errors.user?.razSoc?.message}
          {...register('user.razSoc')}
        />
        <Input
          label="Inscrição Estadual"
          placeholder="Inscrição Estadual"
          errorMessage={errors.user?.stateInscription?.message}
          {...register('user.stateInscription')}
        />
        <Input
          label="Número de Funcionários"
          placeholder="Número de Funcionários"
          errorMessage={errors.user?.functionaryQuantity?.message}
          {...register('user.functionaryQuantity')}
        />
        {isValorize && (
          <div className="min-[748px]:col-span-2">
            <DualSelect
              label="Produtos Comercializados"
              options={planos}
              selected={selectedPlans}
              onChange={newSelected => {
                setSelectedPlans(newSelected);
                setValue(
                  'user.produtosComercializados',
                  newSelected.map(opt => ({
                    id: opt.value.toString(),
                    nome: opt.label,
                  })),
                  { shouldValidate: true },
                );
              }}
              errorMessage={errors.user?.produtosComercializados?.message}
            />
          </div>
        )}
      </div>
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8 mt-16">
        Dados do Responsável pela empresa
      </h2>
      <div className="grid min-[748px]:grid-cols-1 grid-cols-1 gap-6">
        <div className="grid grid-cols-3 gap-8">
          <div className="min-[748px]:col-span-2">
            <Input
              label="Nome completo"
              placeholder="Nome completo"
              errorMessage={errors.user?.fullName?.message}
              {...register('user.fullName')}
            />
          </div>
          <Input
            activateMask
            mask="99/99/9999"
            label="Data de nascimento"
            placeholder="dd/mm/aaaa"
            errorMessage={errors?.user?.birthDate?.message}
            {...register(`user.birthDate`)}
          />
        </div>
        <div className="grid grid-cols-3 gap-8">
          <Input
            label="CPF"
            placeholder="CPF"
            onBlur={validateCPF}
            activateMask
            mask="999.999.999-99"
            errorMessage={errors.user?.documents?.cpf?.message}
            {...register('user.documents.cpf')}
          />
          <Input
            label="E-mail"
            placeholder="E-mail"
            errorMessage={errors.user?.email?.message}
            {...register('user.email')}
          />
          <Input
            label="Telefone"
            activateMask
            mask="(99) 99999-9999"
            placeholder="Telefone"
            errorMessage={errors.user?.phone?.message}
            {...register('user.phone')}
          />
        </div>
        <Input
          label="Logradouro"
          //value={street}
          placeholder="Digite o seu logradouro"
          errorMessage={errors.user?.address?.street?.message}
          {...register('user.address.street')}
        />
        <div className="grid grid-cols-2 gap-8">
          <Input
            label="Complemento"
            placeholder="Digite o seu complemento"
            errorMessage={errors.user?.address?.complement?.message}
            {...register('user.address.complement')}
          />
          <Input
            label="Número"
            //type="number"
            placeholder="Digite o seu número"
            errorMessage={errors.user?.address?.number?.message}
            {...register('user.address.number')}
          />
        </div>
        <div className="grid grid-cols-3 gap-8">
          <Input
            label="Bairro"
            //value={neighborhood}
            placeholder="Digite o seu bairro"
            errorMessage={errors.user?.address?.neighborhood?.message}
            {...register('user.address.neighborhood')}
          />
          <Input
            label="Cidade"
            //value={city}
            placeholder="Digite sua cidade"
            errorMessage={errors.user?.address?.city?.message}
            {...register('user.address.city')}
          />
          <Select
            label="UF"
            options={[]}
            optionsFull={data.listaUFS}
            placeholder="UF"
            errorMessage={errors.user?.address?.uf?.message}
            {...register('user.address.uf')}
          />
        </div>
      </div>
      <GoForwardButton tipo="button" onForwardClick={validaValoriza} />
    </form>
  );
}
